import React, {useState} from "react";
import {
  Grid,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";

const SearchInput = ({ filter, onChange, onReset }) => {
  const classes = useStyles();

  const [search, setSearch] = useState("");
  const handleChangeSearch = ({target}) => {
    setSearch(target?.value || '');
  };
  const handelApplySearch = () => {
    onChange({...filter, search, page: 1}, true)
  }
  const handleReset = () => {
    setSearch("");
    onReset();
  }

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <Typography className={classes.title}>Поиск сотрудника</Typography>
      </Grid>
      <Grid item sx={{minWidth: 340}}>
        <TextField
          fullWidth
          value={search}
          size="small"
          className={classes.input}
          placeholder="Поиск по ФИО"
          onChange={handleChangeSearch}
        />
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          className={classes.button}
          onClick={handelApplySearch}
        >Применить</Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          color="secondary"
          variant="contained"
          className={classes.button}
          onClick={handleReset}
        >Сбросить</Button>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 14,
    lineHeight: 1.2,
    color: "#434146",
  },
  input: {
    "& .MuiOutlinedInput-input": {
      height: "40px",
      boxSizing: "border-box",

      fontSize: 16,
    }
  },
  button: {
    height: 40,

    "&.MuiButton-containedSecondary": {
      backgroundColor: "#F3F3F3",
      color: "#434146",
    }
  }
}));

export default SearchInput;
